import React, {Component} from "react";
import {Redirect, Link} from 'react-router-dom';
import {Layout} from 'antd';
import memoryUtils from "../../utils/memoryUtils";
import Header from "../../components/header";
import './home.less';

const {Content} = Layout;
/**
 * 主页的路由组件
 */
export default class Home extends Component {

    componentDidMount = async () => {
        sessionStorage.clear();
        document.getElementsByClassName("logo")[0].setAttribute("hidden", true);

        document.getElementsByClassName("logo_t")[0].style.display='block';
    };

    render() {
        const user = memoryUtils.user;
        if (!user || !user.userId) {
            //跳转登录页(在render中)
            return <Redirect to='/login'/>;
        }
        return (
            <Layout style={{height: '100%'}}>
                <Header>Header</Header>
                <Content style={{background: '#eef5ff'}}>

                    <img className="bg1" src={require('./images/index_bg1.png')}/>
                    <img className="bg2" src={require('./images/index_bg2.png')}/>
                    <div className="login_foot">
                        技术支持：
                        <a style={{color: '#12c4ed'}} href="http://www.ugion.com/">上海域圆信息科技有限公司</a>
                    </div>
                    <div className='row'>
                        <div className="item">
                            <Link to='/skill' className="link1">
                                <div className="icon">
                                    <img src={require('./images/case.png')}/>
                                </div>
                                <span className="title">舌面诊训练</span>
                            </Link>
                        </div>
                        <div className="item">
                            <Link to='/cover' className="link2">
                                <div className="icon">
                                    <img src={require('./images/test.png')}/>
                                </div>
                                <span className="title">考核测试</span>
                            </Link>
                        </div>
                        <div className="item">
                            <Link to='/basic' className="link3">
                                <div className="icon">
                                    <img src={require('./images/basic.png')}/>
                                </div>
                                <span className="title">基础知识</span>
                            </Link>
                        </div>
                        <div className="item">
                            <Link to='/care' className="link4">
                                <div className="icon">
                                    <img src={require('./images/human.png')}/>
                                </div>
                                <span className="title">人文关怀</span>
                            </Link>
                        </div>
                        <div className="item">
                            <Link to='/question' className="link5">
                                <div className="icon">
                                    <img src={require('./images/ques.png')}/>
                                </div>
                                <span className="title">问题解答</span>
                            </Link>
                        </div>
                        <div className="item">
                            <Link to='/intel' className="link6">
                                    <div className="icon">
                                        <img src={require('./images/intel.png')}/>
                                    </div>
                                    <span className="title">智能舌面诊</span>
                            </Link>
                        </div>
                    </div>
                </Content>
            </Layout>
        )
    }
}